/**
 * @flow
 */

// eslint-disable-next-line i18next/no-literal-string
export const apiBase = "/api/v1/";

// Our server kills requests after 30 seconds of 'live' time.
// There could also be queue time, so we pad that by 15 seconds.
export const FETCH_TIMEOUT_MS = 45000;

export const HTTP_202_ACCEPTED = 202;
export const HTTP_204_NO_CONTENT = 204;
export const HTTP_401_UNAUTHORIZED = 401;
